import {
  configAxios,
  getAxiosConfig,
  getClientAuthenticatedConfig,
} from 'services/apiConfig';
import { createLog } from 'services/logService';

import { getToday } from 'utils/date';

export const getGroupTalkHistory = async (req, res) => {
  try {
    const config = await getAxiosConfig(req, res);
    const response = await config.get(
      `students/meeting/history?MeetingTypeId=1&StatusId=1`
    );

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const getPrivateTalkHistory = async (req, res) => {
  try {
    const config = await getAxiosConfig(req, res);
    const response = await config.get(
      `students/meeting/history?MeetingTypeId=2`
    );

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const getStudentProfile = async (req, res) => {
  try {
    const config = await getAxiosConfig(req, res);
    const response = await config.get(`students/profile`);

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const updateStudent = async (req, res) => {
  try {
    const config = await getAxiosConfig(req, res);
    const response = await config.put(`students/update`, {
      ...req.body,
    });

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const createLead = (leadStudent) => {
  try {
    const response = configAxios.post(`students/leadStudent`, leadStudent);
    return response;
  } catch (error) {
    return createLog(error);
  }
};

export const updateLead = (leadStudent) => {
  try {
    const response = configAxios.post(`students/updateLead`, leadStudent);
    return response;
  } catch (error) {
    return createLog(error);
  }
};

export const createStudent = async (data) => {
  try {
    const response = await configAxios.post(`students/registration`, data);

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const fetchLanguageLevels = async () => {
  try {
    const response = await configAxios.get(`students/languageLevels`);

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const fetchStudentByOrder = async (hash) => {
  try {
    const response = await configAxios.get(`students/orders/${hash}`);

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const fetchLeadByIdentifier = async (hash) => {
  try {
    const response = await configAxios.get(`students/lead/${hash}`);

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const postGuardian = async (req, res) => {
  try {
    const config = await getAxiosConfig(req, res);

    const response = await config.post('students/guardian', req.body);

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const removeGuardian = async (req, res) => {
  try {
    const config = await getAxiosConfig(req, res);

    const response = await config.put('students/remove/guardian', req.body);

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const getOnboardingSummary = async (req, res) => {
  try {
    const config = await getAxiosConfig(req, res);

    const response = await config.get('students/onboarding-summary');

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const getStudentStreak = async (req, res, id) => {
  try {
    const config = await getAxiosConfig(req, res);
    const today = getToday();

    const response = await config.get(
      `students/streak?selectedDate=${today}${id ? `&identifier=${id}` : ''}`
    );

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const getAuthStudentStreak = async (userToken, id) => {
  try {
    const config = await getClientAuthenticatedConfig(userToken);

    const today = getToday();

    const response = await config.get(
      `students/streak?selectedDate=${today}${id ? `&identifier=${id}` : ''}`
    );

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const getMeetingLessons = async (req, res) => {
  try {
    const config = await getAxiosConfig(req, res);
    const response = await config.get(
      `students/meetingLessons?meetingType=${req?.query?.meetingType}&skillId=${req?.query?.skillId}`
    );

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const getStudentSubscription = async (req, res) => {
  try {
    const config = await getAxiosConfig(req, res);

    const response = await config.get('students/subscription-setups');

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};
